import React, { useCallback, useState } from 'react';
import { Tab, Tabs, InputGroup, FormControl, Button, Row, Col, Form } from 'react-bootstrap';
import '../css/styles.css'
import { Server } from "../../../constants";
import axios from 'axios';
import { FaAngleRight } from 'react-icons/fa';
import { Spinner } from 'react-bootstrap';
import Tucson from '../assets/tucson.png'
import Kona from '../assets/kona.png'
import Staria from '../assets/staria.png'
import { useMemo } from 'react';

const Step1 = ({ onContinuar, updateModeloVehiculo, updateModeloAgrupador, updateMantenimiento, updatePlaca, updateModeloVehiculoYear, updateCodigoModeloYear, updatePeriodo, updateYearP, updateActivekey, updateVin }) => {
  const [placa, setPlaca] = useState('');
  const [activeKey, setActiveKey] = useState('placa');
  const [modeloVehiculo, setModeloVehiculo] = useState(null);
  const [imagenCarroPlaca, setImagenCarroPlaca] = useState('');
  const [imagenCarroModelo, setImagenCarroModelo] = useState('');
  const [mostrarBotonContinuar, setMostrarBotonContinuar] = useState(false);
  const [modeloAgrupador, setModeloAgrupador] = useState(null);
  const [mantenimiento, setMantenimiento] = useState(null);
  const [modelosVehiculo, setModelosVehiculo] = useState([]);
  const [year, setYear] = useState("");
  const [yearP, setYearP] = useState("");
  const [vin, setVin] = useState("");
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedValue, setSelectedValue] = useState('');
  const [imagenModeloSeleccionado, setImagenModeloSeleccionado] = useState('');
  const [codigoModelo, setCodigoModelo] = useState("");
  const [errorMensaje, setErrorMensaje] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingYearImage, setLoadingYearImage] = useState(false);

  const setTabStyle = (key) => {
    if (activeKey === 'placa' && key === 'placa') {
      return 'active-tab-placa';
    } else if (activeKey === 'datosVehiculo' && key === 'datosVehiculo') {
      return 'active-tab-datosVehiculo';
    } else {
      return '';
    }
  };


  const obtenerModelosVehiculo = async (value) => {
    if (String(value).length === 4) {
      let versionesApi = parseInt(value) >= 2022 ? '7k' : '5k';
      try {
        const response = await axios.get(`${Server}/api/vehiculos/getModelosPrepagados/${versionesApi}/${value}`);
        setModelosVehiculo(response.data.data.map((modelo) => ({
          value: modelo.MP_VER_ID,
          label: modelo.MP_VER_COMERCIAL,
          imagen: modelo.MP_VER_IMAGEN,
          MP_VER_KM: modelo.MP_VER_KM,
          MP_TIPO: modelo.MP_TIPO,
          MP_VER_CODIGO: modelo.MP_VER_CODIGO,
        })));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handlePlacaChange = (event) => {
    setPlaca(event.target.value);
  };

  const handleBuscarClick = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.get(`${Server}/api/mprepagados/vehiculos/${placa}`);
      const vehiculo = response.data[0];
      console.log(vehiculo);
      setModeloAgrupador(vehiculo.modelo_agrupador);
      setMantenimiento(vehiculo.mantenimiento);
      setYearP(vehiculo.anio_modelo)
      setVin(vehiculo.ve_chasis)
      updatePlaca(placa);
      const responseVersiones = await axios.get(`${Server}/api/mprepagados/versiones/${vehiculo.mantenimiento}k`);
      const versiones = responseVersiones.data;

      let modelo = versiones.find(version => {
        const modeloWords = vehiculo.modelo_agrupador.split(' ').slice(0, 1).join(' ').toLowerCase();
        const versionWords = version.MP_VER_DETALLE.split(' ').slice(0, 1).join(' ').toLowerCase();
        return modeloWords === versionWords;
      });
      console.log(modelo);
      if (modelo) {
        modelo = {
          value: modelo.MOD_CODIGO + "/" + modelo.MP_VER_CODIGO + "/" + modelo.MP_VER_KM,
          label: modelo.MP_VER_DETALLE,
          imagen: modelo.MP_VER_IMAGEN,
          MP_VER_KM: modelo.MP_VER_KM,
          MP_TIPO: modelo.MP_TIPO,
          MP_VER_CODIGO: modelo.MP_VER_CODIGO,
        };
        setModeloVehiculo(modelo);
        setImagenCarroPlaca(modelo.imagen);
        setImagenModeloSeleccionado(modelo.imagen);
        setMostrarBotonContinuar(true);
        updateModeloVehiculo(modelo);
        setErrorMensaje('');
      }
    } catch (err) {
      console.error(err);
      setErrorMensaje('PLACA SIN COINCIDENCIA');
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
    if (key !== 'placa') {
      setImagenCarroPlaca('');
      setModeloVehiculo(null);
      setImagenCarroPlaca('');
      setImagenModeloSeleccionado('');
      setMostrarBotonContinuar(false);
    } else {
      setImagenCarroModelo('')
      setModeloVehiculo(null);
    }
  };

  const handleModeloChange = useCallback(async (event) => {
    const selectedValue = Number(event.target.value);
    const selectedModelo = modelosVehiculo.find((modelo) => modelo.value === selectedValue);
    setSelectedValue(selectedValue);
    setImagenCarroModelo('');
    if (selectedModelo) {
      updatePeriodo(selectedModelo.MP_VER_KM);
      updateCodigoModeloYear(selectedModelo.MP_VER_CODIGO);
      setImagenModeloSeleccionado(selectedModelo.imagen)
      setImagenCarroModelo(selectedModelo.imagen);
      setSelectedModel(selectedModelo);
      setModeloAgrupador(selectedModelo.label);
      setModeloVehiculo(selectedModelo);
      setMostrarBotonContinuar(true);
      setCodigoModelo(codigoModelo);
    }
  }, [modelosVehiculo, codigoModelo, updateCodigoModeloYear, updatePeriodo]);

  const setTitleColor = (key) => {
    return activeKey === key ? 'black' : '#333333';
  };

  let codigoModeloYear, periodo;

  if (modeloVehiculo) {
    codigoModeloYear = modeloVehiculo.codigoModeloYear;
    periodo = modeloVehiculo.periodo;
  }

  const handleContinuarClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const modeloConImagen = {
      ...modeloVehiculo,
      imagen: imagenModeloSeleccionado,
      codigoModeloYear,
      periodo
    };
    updateModeloVehiculo(modeloConImagen);
    updateModeloVehiculoYear(modeloConImagen);
    updateModeloAgrupador(modeloAgrupador);
    updateMantenimiento(mantenimiento);
    updateYearP(yearP)
    updateVin(vin)
    onContinuar();
    updateActivekey(activeKey)
  };

  useMemo(() => {
    handleModeloChange({ target: { value: selectedValue } });
  }, [selectedValue, handleModeloChange]);

  const handleYearChange = (event) => {
    const value = event.target.value;
    if ((value !== '' && isNaN(Number(value))) || value.length > 4) {
      return;
    }
    setYear(value);
    setLoadingYearImage(true);
    try {
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingYearImage(false);
    }
    obtenerModelosVehiculo(value);
  }

  return (
    <div className="paso1">
      <Row >

        <Col className='form1 order-sm-1'>
          <Tabs defaultActiveKey="placa" id="paso1-tabs" activeKey={activeKey} onSelect={handleTabChange} className="tabs-container" >
            <Tab
              eventKey="placa"
              title={
                <>
                  <span className="FontLight" style={{ color: setTitleColor('placa'), fontSize: "16px" }}>Número de Placa</span>
                </>
              }
            >
              <hr className={`${setTabStyle('placa')} medium-width-line`} />
              <Row className='mt-4'>
                <Col xs={10} sm={6} md={6}>
                  <Form onSubmit={handleBuscarClick}>
                    <InputGroup className="mb-3 ml-3">
                      <FormControl
                        className='higher-input '
                        type="text"
                        value={placa}
                        onChange={handlePlacaChange}
                        placeholder="PPP0000"
                      />
                      <InputGroup.Append>
                        <Button className='btn-custom' type="submit" disabled={loading}>
                          {loading ? <Spinner animation="border" size="sm" /> : "Buscar"}
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                    {errorMensaje && <p className='error-message'>{errorMensaje}</p>}
                  </Form>
                </Col>
              </Row>

            </Tab>
            <Tab
              eventKey="datosVehiculo"
              title={
                <>
                  <span style={{ color: setTitleColor('datosVehiculo'), fontFamily: "HyundaiSansHead-Light", fontSize: "16px" }} >Datos del Vehículo</span>
                </>
              }
            >
              <hr className={`${setTabStyle('datosVehiculo')} medium-width-line`} />
              <Row className='mt-4'>
                <Col sm={7}>
                  <Row>
                    <label className=" ml-4">*Año</label>
                  </Row>
                  <Row>
                    <Col xs={10} sm={7} md={7} style={{ marginLeft: '-23px' }}>
                      <InputGroup className="mb-4 ml-4">
                        <FormControl
                          type="text"
                          value={year}
                          onChange={handleYearChange}
                          placeholder="Año de fabricación"
                          className='higher-input ml-4 '
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row>
                    <label className='ml-4'>*Modelo</label>
                  </Row>
                  <Row>
                    <InputGroup className="mb-4 ml-4">
                      <FormControl as="select" value={selectedValue} onChange={handleModeloChange} className='higher-input ml-3'>
                        <option value="">Seleccione modelo del vehículo</option>
                        {modelosVehiculo.map((modelo, index) => (
                          <option key={index} value={modelo.value}>{modelo.label}</option>
                        ))}
                      </FormControl>
                    </InputGroup>
                  </Row>
                </Col>
              </Row>
            </Tab>
          </Tabs>
          <Row className='ml-1'>
            {mostrarBotonContinuar &&
              <Button
                variant="primary"
                onClick={handleContinuarClick}
                className='button-below button-below-movil'>
                Continuar<FaAngleRight style={{ marginLeft: '10px' }} />
              </Button>
            }

          </Row>
        </Col>


        <Col sm={6} md={6} className="text-center  order-sm-1">
          <Col >
            {(imagenCarroPlaca || imagenCarroModelo) ? (
              <div className="car-image-container car-container-margin ">
                <div className={activeKey === 'placa' ? "car-model-description" : "car-model-description-alternate"}>
                  <div className='column'>
                    <span className='texttitle'>Marca:</span>
                    <span className='modeltext'> Hyundai</span>
                  </div>
                  <div className="column">
                    <span className='texttitle'>Modelo de Vehiculo:</span>
                    {modeloAgrupador && <span className='modeltext'> {modeloAgrupador}</span>}
                  </div>
                  {activeKey === 'placa' && (
                    <div className="column">
                      <span className='texttitle'>Año:</span>
                      {modeloAgrupador && <span className='modeltext'> {yearP}</span>}
                    </div>
                  )}
                  {activeKey === 'placa' && (
                    <div className="column">
                      <span className='texttitle' >VIN: </span>
                      <span className='modeltext'>{vin}</span>
                    </div>
                  )}
                </div>
                {
                  imagenCarroPlaca && (
                    <img
                      src={
                        imagenCarroPlaca ===
                          'https://www.hyundai.com.ec/static/media/3.55469fd0.png'
                          ? Tucson
                          : imagenCarroPlaca ===
                            'https://kerner.hyundai.com.ec/images/spincar360/1039/3/img1.png'
                            ? Kona
                            : imagenCarroPlaca ===
                              'https://kerner.hyundai.com.ec/images/spincar360/1037/224/img7.png'
                              ? Staria
                              : imagenCarroPlaca
                      }
                      alt="Carro"
                      className="car-image"
                    />
                  )
                }
                {imagenCarroModelo && (loadingYearImage ? (
                  <Spinner animation="border" />
                ) : (
                  <img
                    src={
                      
                             imagenCarroModelo
                    }
                    alt="Carro"
                    className="car-image"
                  />
                ))}
              </div>
            ) : (
              <span className="question-mark">?</span>
            )}
          </Col>
        </Col>

        {/* {selectedModel && year &&
          <Button
            variant="primary"
            onClick={handleContinuarClick}
            className='button-below'>
            Continuar<FaAngleRight style={{ marginLeft: '10px' }} />
          </Button>
        } */}
      </Row>
    </div>
  );
};

export default Step1;